import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import moment from "moment";
import OrderFilter from "./OrderFilter";
import { useState } from "react";
import ScanQrCode from "./ScanQrCode";
import OrderMenu from "./OrderMenu";
import PrintActionMenu from "./PrintActionMenu";
import Modal from "../Reusable/Modal";
import OrderActionMenu from "./OrderActionMenu";
import { toast } from "react-toastify";
import usePostHook from "../../customHooks/usePostHook";

import { useForm } from "react-hook-form";
import Remark from "./Remark";
import useGetHook from "../../customHooks/useGetHook";
import { useSearchParams } from "react-router-dom";
import OrderHistory from "./OrderHistory";
import { classNames } from "../../utils/classNames";
import { queryClient } from "../../root.component";
import NACell from "../Reusable/DataTable/NACell";

const OrderList = () => {
  const [searchParams, setSearchParms] = useSearchParams()

  const {
    register,
    setValue,
    getValues,
    watch,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({});
  const [isFilterVisible, setFilterVisiable] = useState(false)
  const [openPrintPopup, setOpenPrintPDF] = useState(false)
  const [selectedPDFType, setSelectedPDFType] = useState(false)
  const [pageSize, setPageSize] = useState("A4")
  const [orderActionMenu, setOrderActionMenu] = useState(false)
  const [actionType, setActionType] = useState("")
  const [openReviewModal, setOpenReviewModal] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState("")
  const [openHistoryPopup, setOpenHistoryPopup] = useState(false)
  const [defaultValue, setDefaultValue] = useState(null)


  const handleFilterReset = () => {
    reset()
    setValue("is_rtv", null)
    setValue("order_remarks__isnull", null)
    setValue("is_walking_customer", null)
    setValue("delivery_status__in", null)
    setDefaultValue(null)
  }

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
    navigateURL: "",
  });

  const checkedAllItems = searchParams.get("selectAllItems") === "1"
  const handlePrint = () => {
    alert("Print is not implemented")
  }
  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",")
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return
    }
    let itemIndex = selectedItems?.findIndex(item => item === value)
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems?.map(item => item).join(",").toString()
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems")
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value)
      const newSelectedItems = selectedItems?.map(item => item).join(",").toString()
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  }

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",")
    if (!selectedItems) {
      return false
    }
    return selectedItems.includes(value)
  }

  const handleSelectAll = (table: any) => {
    const { options: { data: tableData } } = table
    const isSelected = searchParams.get("selectAllItems")
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData?.map((item: any) => item.id).join(",").toString()
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  }


  let defaultColumns: any = [
    {
      id: 'select',
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className='cursor-pointer'
          />
        )
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className='cursor-pointer'
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <div onClick={() => {
            setSelectedOrder(row?.original?.id);
            setOpenHistoryPopup(true);
          }} className={"cursor-pointer"}>
            <p className={classNames(row?.original?.is_duplicate ? "text-red-600" : "", "whitespace-nowrap")}>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{moment(row?.original?.created).format('YY-MM-DD HH:mm:ss')}</p>
          </div>
        )
      },
    },
    {
      header: "Vendor",
      accessorKey: "merchant.name",
      cell: NACell
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className="uppercase">{getValue()}</p>
            <p className="text-xs text-primary">{row?.original?.pickup_branch?.warehouse?.name}</p>
          </>
        )
      },
    },
    {
      header: "Destination",
      accessorKey: "destination.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className="uppercase">{getValue()}</p>
            <p className="text-xs text-primary">{row?.original?.destination_branch?.warehouse?.name}</p>
          </>
        )
      },
    },
    {
      header: "Customer",
      accessorKey: "sender.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{row?.original?.customer_full_address}</p>
            <p className="text-xs text-gray-500 block">{row?.original?.customer_mobile_number1}</p>
            <p className="text-xs text-gray-500">{row?.original?.customer_mobile_number2}</p>
          </>
        )
      },
    },
    {
      header: "Finance",
      accessorKey: "delivery_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className="whitespace-nowrap">COD: {row?.original?.cod ?? 0.00} </p>
            <p className="whitespace-nowrap">Collected: {row?.original?.collected_cod ?? 0.00}</p>
            <p className="whitespace-nowrap">D. Charge:{getValue()}</p>
          </>
        )
      },
    },
    {
      header: "Weight",
      accessorKey: "weight",
      cell: ({ row, getValue }: any) => {

        return (
          <>
            <p>{getValue()}<span className="text-gray-500 text-xs">Kgs</span> </p>
          </>
        )
      },
    },
    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => <button onClick={() => {
        setSelectedOrder(row?.original?.id)
        setOpenReviewModal(true)
      }}>
        {getValue()} Remarks
      </button>
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {

        return (
          <>
            <p className={`uppercase px-1 text-center rounded-md`} style={{ background: row?.original?.delivery_status?.color }}>{getValue()}</p>
            <p className="text-xs text-primary ">{row?.original?.rider?.name}</p>
          </>
        )
      },
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    }
  ];

  const handleStatusUpdate = async (selectedOrder: any, data: any, setError: any) => {
    const url = `${APIS.ORDER}change-status/`;
    let formData = {
      order_ids: selectedOrder,
      status: data?.status,
      remark: data?.remark,
      collected_cod: data?.collected_cod
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false)
        queryClient.refetchQueries()
      }
    } catch (err) {
      toast.success("Somethings went wrong")
    }

  }

  const handleAssignToRider = async (selectedOrder: any, data: any, setError: any) => {
    const url = `${APIS.ORDER}assign-rider/`;
    let formData = {
      order_ids: selectedOrder,
      status: data?.status,
      rider: data?.rider,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false)
        queryClient.refetchQueries()
      }
    } catch (err) {
      toast.success("Somethings went wrong")
    }


  }

  const handleOrderExchange = async (selectedOrder: any, data: any, setError: any) => {
    const url = `${APIS.ORDER}exchange-order/`;
    let formData = {
      order_ids: selectedOrder,
      cod: data?.cod,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false)
        queryClient.refetchQueries()
      }
    } catch (err) {
      toast.success("Somethings went wrong")
    }


  }

  const handleReverseOrder = async (selectedOrder: any, data: any, setError: any) => {
    const url = `${APIS.ORDER}rtv-return/`;
    let formData = {
      order_ids: selectedOrder,
      refund_amount: data?.refund_amount,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false)
        queryClient.refetchQueries()
      }
    } catch (err) {
      toast.success("Somethings went wrong")
    }

  }

  const handleExraMileOrderCharge = (selectedOrder: any, data: any, setError: any) => {
    toast.success("Extra Mile Charges added successfully")

  }

  const handleCreateTransit = (selectedOrder: any, data: any, setError: any) => {
    toast.success("Transit Create successfully for selected order")

  }

  const handleActionMenu = (data: any, type: string, setError: any) => {

    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder) {
      toast.error("Please select at least one order first")
      setOrderActionMenu(false)
      return
    }
    if (type === "Change Status") {
      handleStatusUpdate(selectedOrder, data, setError)
    } else if (type === "Assign To Rider") {
      handleAssignToRider(selectedOrder, data, setError)
    } else if (type === "Exchange") {
      handleOrderExchange(selectedOrder, data, setError)
    } else if (type === "RTV/Return") {
      handleReverseOrder(selectedOrder, data, setError)
    } else if (type === "Extra Mile Charge") {
      handleExraMileOrderCharge(selectedOrder, data, setError)
    } else if (type === "Transit") {
      handleCreateTransit(selectedOrder, data, setError)
    }
  }
  const filterParams = watch()

  return (
    <>
      <Card
        title="Filters"
        onClick={() => setFilterVisiable(!isFilterVisible)}
      >
        <OrderFilter
          isFilterVisible={isFilterVisible}
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          reset={handleFilterReset}
          watch={watch}
          clearErrors={clearErrors}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
      </Card>
      <DataTable
        url={APIS.ORDER}
        queryKey={"orders"}
        columns={defaultColumns}
        addNewPagePath={ "/create-order"}
        tableName={"Consignments"}
        isUpload={false}
        isDownload={true}
        params={{
          ...filterParams,
          is_rtv: filterParams?.is_rtv ? true : null,
          order_remarks__isnull: filterParams?.order_remarks__isnull ? false : null,
          is_walking_customer: filterParams?.is_walking_customer ? true : null,
          delivery_status__in: filterParams?.delivery_status__in?.map((item: any) => (item.id)).join(",")
        }}
        actionMenu={
          <div className="flex w-full">
            <ScanQrCode
              setValue={setValue}

            />
            <OrderMenu
              orderActionMenu={orderActionMenu}
              setOrderActionMenu={setOrderActionMenu}
              setActionType={setActionType}
            />
            <PrintActionMenu
              setOpenPrintPDF={setOpenPrintPDF}
              setSelectedPDFType={setSelectedPDFType}
            />
          </div>
        }
      />
      <Modal
        isOpen={orderActionMenu}
        setIsOpen={setOrderActionMenu}
        title={actionType}
        children={<>
          <OrderActionMenu
            handleActionMenu={handleActionMenu}
            actionType={actionType}
            isLoading={isPostLoading}
          />
        </>}
      />
      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
        children={<>
          <Remark
            selectedOrder={selectedOrder}
          />
        </>}
      />
      <Modal
        isOpen={openHistoryPopup}
        setIsOpen={setOpenHistoryPopup}
        title={"History"}
        children={<>
          <OrderHistory selectedOrder={selectedOrder} />
        </>}
      />
    </>
  );
};

export default OrderList;
